import { Col, Result, Row } from "antd";
import { useEffect } from "react";
import PageBanner from "../../components/PageBanner";
import PageBreadcrumb from "../../components/PageBreadcrumb";
import PageLayout from "../../components/PageLayout";
import StandardPageBlock from "../../components/StandardPageBlock";
import { getImageById } from "../../getters/images";
import { setPageTitle, STANDARD_GUTTER } from "../../utils";

const breadcrumbs = [{ link: "", value: "Projets en cours" }];

const ProjectsOnGoing = () => {
  useEffect(() => {
    setPageTitle("Projets en cours");
  }, []);

  return (
    <div className="projects-ongoing">
      <PageLayout>
        <>
          <PageBanner
            image={getImageById("1646455366852")}
            title="Nos projets en cours"
          />
          <PageBreadcrumb items={breadcrumbs} />
          <StandardPageBlock>
            <Row gutter={STANDARD_GUTTER * 3} justify="center">
              <Col xs={24} md={12}>
                <Result status={404} title="Pas de projet en cours" />
              </Col>
            </Row>
          </StandardPageBlock>
        </>
      </PageLayout>
    </div>
  );
};

export default ProjectsOnGoing;
